@if (multiple && hasCheckbox) {
  <campus-checkbox
    type="checkbox"
    [checked]="selected"
    [disabled]="disabled"
    [indeterminate]="indeterminate"
    aria-hidden="true"
    class="pointer-event-none"
    pseudo
  ></campus-checkbox>
}
@if (leadingIcon) {
  <campus-icon [svgIcon]="leadingIcon"></campus-icon>
}

<div class="[ stack stack-space-3xs ][ grow ]">
  @if (overline) {
    <span class="[ label-overline ]">{{ overline }}</span>
  }
  @if (label) {
    <span class="[ body-large ]">{{ label }}</span>
  }
  @if (supportingText) {
    <span class="[ body-small on-surface-variant ]">{{ supportingText }}</span>
  }
</div>

@if (trailingSupportingText) {
  <span class="[ label-small on-surface-variant ]">{{ trailingSupportingText }}</span>
}

<campus-state-layer [for]="element" class="bg-on-surface"></campus-state-layer>
<campus-focus-ring [for]="element" inward></campus-focus-ring>
